export default __webpack_public_path__ + "locales/fi/Article.json?hash=2df92f4768b8ccec674d706918b57964";